import { AdditionalInfoImpl } from './additional-info-impl';
import { Expose, Type } from 'class-transformer';

export class NVRStatus extends AdditionalInfoImpl {

  @Expose({ name: 'bay_error' })
  bayError: string;

  @Expose({ name: 'locked' })
  bayLocked: number;

  @Expose({ name: 'cams' })
  cams: string;

  @Expose({ name: 'curr' })
  discCurr: number;

  @Expose({ name: 'expe' })
  discExpe: number;

  @Expose({ name: 'smart' })
  discSmart: number;

  @Expose({ name: 'proc_error' })
  procError: string;

  @Expose({ name: 'proc_version' })
  procVersion: string;

  @Expose({ name: 'rec' })
  rec: number;

  @Expose({ name: 'version' })
  version: string;

  @Expose({ name: 'address' })
  address: string;

  @Expose({ name: 'time' })
  @Type(() => Date)
  time: string;

  @Expose({ name: 'camsJSON' })
  camsJSON: string;
}
